import { Observable } from 'rxjs';
import {
  ApiService,
  GET_GAME_LINEUPS_PATH,
  GetGameLineupsPathParams,
  GetGameLineupsResponse,
  UPDATE_GAME_LINEUPS_PATH,
  UpdateGameLineupsBody,
  UpdateGameLineupsPathParams,
  UpdateGameLineupsResponse
} from '@core-http';

export class LineupsService extends ApiService {
  getLineups(pathParams: GetGameLineupsPathParams): Observable<GetGameLineupsResponse> {
    const path: string = this.fillPathParams(GET_GAME_LINEUPS_PATH, pathParams);

    return this.httpClient.get<GetGameLineupsResponse>(`${this.env.apiUrl}${path}`);
  }

  save(pathParams: UpdateGameLineupsPathParams, payload: UpdateGameLineupsBody): Observable<UpdateGameLineupsResponse> {
    const path: string = this.fillPathParams(UPDATE_GAME_LINEUPS_PATH, pathParams);

    return this.httpClient.put<UpdateGameLineupsResponse>(`${this.env.apiUrl}${path}`, payload);
  }
}
